<template>
  <div class="page">
    <div class="partition-one">
      <h3>
        {{ "for_business.titles.empower" | translate }}
      </h3>
      <p>{{ "for_business.descriptions.empower" | translate }}</p>
      <div class="button">
        <a href="mailto:info@gyra.shop" class="link"
          ><p>{{ "for_business.titles.request_demo" | translate }}</p></a
        >
      </div>
    </div>

    <div class="partition-two">
      <div class="img position"></div>
      <div class="gradient position"></div>
    </div>

    <div class="page-gradient">
      <div class="partition-three">
        <h3>
          {{ "for_business.titles.new_way" | translate }}
        </h3>
        <p>{{ "for_business.descriptions.new_way" | translate }}</p>
        <div class="mockups">
          <div class="mockup">
            <div class="img one"></div>
            <h3>{{ "for_business.titles.benefit" | translate }}</h3>
            <p>{{ "for_business.descriptions.benefit" | translate }}</p>
          </div>
          <div class="mockup">
            <div class="img two"></div>
            <h3>{{ "for_business.titles.pull" | translate }}</h3>
            <p>{{ "for_business.descriptions.pull" | translate }}</p>
          </div>
          <div class="mockup">
            <div class="img three"></div>
            <h3>{{ "for_business.titles.showcase" | translate }}</h3>
            <h3 class="nomarg"></h3>
            <p>{{ "for_business.descriptions.showcase" | translate }}</p>
          </div>
        </div>
      </div>

      <div class="partition-four">
        <h3>
          {{ "for_business.titles.stay_ahead" | translate }}
        </h3>
        <p>{{ "for_business.descriptions.stay_ahead" | translate }}</p>
        <div class="button">
          <a href="mailto:info@gyra.shop" class="link"
            ><p>{{ "for_business.titles.lets_meet" | translate }}</p></a
          >
        </div>
      </div>
    </div>

    <div class="partition-five">
      <div class="left">
        <h3>
          {{ "for_business.titles.daring" | translate }}
        </h3>
        <p>{{ "for_business.descriptions.daring" | translate }}</p>
      </div>
      <div class="right">
        <div class="img"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ForBusinessPage"
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.page {
  width: 100%;
  min-height: 100vh;
  position: relative;
}
h3 {
  font-size: 30px;
  font-weight: bold;
  @media (min-width: $gyra-breakpoint-md) {
    font-size: 46px;
  }
}
p {
  font-size: 14px;
  font-weight: 500;
  @media (min-width: $gyra-breakpoint-md) {
    font-size: 16px;
  }
}
.button {
  @media (min-width: $gyra-breakpoint-md) {
    width: 275px;
    height: 58px;
  }
  width: 200px;
  height: 50px;
  background-color: $gyra-salmon;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 100px;
  p {
    margin: 0;
    width: 100%;
  }
  a {
    width: 100%;
  }

  .link {
    color: $gyra-salmon;
    text-decoration: underline;
    cursor: pointer;
    text-align: center;
  }
}
.partition-one {
  display: flex;
  min-height: 60vh;
  width: 100%;
  align-items: center;
  flex-direction: column;
  h3 {
    margin-top: 100px;
    text-align: center;
    @media (min-width: $gyra-breakpoint-md) {
      margin-top: 265px;
    }
  }
  p {
    margin-top: 50px;
    width: 80%;
    @media (min-width: $gyra-breakpoint-md) {
      width: 60%;
    }
    text-align: center;
  }
  .button {
    margin-top: 100px;
    @media (min-width: $gyra-breakpoint-md) {
      margin-top: 128px;
    }
    p {
      @media (min-width: $gyra-breakpoint-md) {
        font-size: 16px;
      }
      font-size: 14px;
      font-weight: bold;
      width: 100%;
      margin: 0;
    }
  }
}
.partition-two {
  width: 100%;
  min-height: 500px;
  position: relative;
  .position {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    @media (min-width: $gyra-breakpoint-md) {
      height: calc(0.455 * 100vw);
    }
    height: 500px;
  }
  .img {
    background-image: url("../assets/images/for_business/helsinkigoeshelsinki-2.png");
    background-position: center;
    background-size: cover;
    @media (min-width: $gyra-breakpoint-md) {
      background-size: contain;
    }
    background-repeat: no-repeat;
  }
  .gradient {
    background: rgb(255, 255, 255);
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 23%,
      rgba(255, 255, 255, 0) 59%
    );
  }
}
.partition-three {
  display: flex;
  flex-direction: column;
  align-items: center;
  h3,
  p {
    text-align: center;
    z-index: 10;
  }
  h3 {
    margin-top: 0;
    @media (min-width: $gyra-breakpoint-xl) {
      margin-top: 200px;
    }
  }
  p {
    margin-top: 47px;
    width: 80%;
    @media (min-width: $gyra-breakpoint-md) {
      width: 60%;
    }
  }

  .mockups {
    margin-top: 60px;
    display: flex;
    width: 100%;
    justify-content: space-evenly;
    flex-direction: column;
    align-items: center;
    @media (min-width: $gyra-breakpoint-md) {
      flex-direction: row;
      margin-top: 180px;
      align-items: unset;
      padding: 0 $gyra-margin-sides;
    }
    padding: 0;

    .mockup {
      max-width: 400px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .nomarg {
        margin: 0;
        height: 36px;
      }
      h3,
      p {
        text-align: center;
        width: 100%;
      }
      h3 {
        margin-top: 74px;
        font-size: 16px;
        font-weight: bold;
        @media (min-width: $gyra-breakpoint-md) {
          font-size: 30px;
        }
      }
      p {
        margin-top: 26px;
        font-size: 14px;
        width: 80%;
        @media (min-width: $gyra-breakpoint-md) {
          font-size: 18px;
          width: 100%;
        }
        font-weight: 500;
        margin-bottom: 100px;
      }
    }

    .three {
      background-image: url("../assets/images/for_business/smartmockups_kews3cq9.png");
    }
    .two {
      background-image: url("../assets/images/for_business/smartmockups_kews3rxm.png");
    }
    .one {
      background-image: url("../assets/images/for_business/smartmockups_kews4ani.png");
    }

    .img {
      height: calc(26vw * 2.5);
      @media (min-width: $gyra-breakpoint-md) {
        height: calc(26vw * 1.2);
        width: 26vw;
      }
      width: 40vw;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: relative;
    }
    .img::after {
      content: "";
      z-index: -10;
      display: flex;
      align-items: center;
      position: absolute;
      bottom: -10px;
      background-color: $gyra-salmon;
      width: 26vw;
      height: calc(26vw * 0.3);
      border-radius: 50%;
    }
  }
}
.partition-four {
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: column;
  h3 {
    margin-top: 100px;
    text-align: center;
  }
  p {
    margin-top: 70px;
    width: 80%;
    @media (min-width: $gyra-breakpoint-md) {
      width: 60%;
    }
    text-align: center;
  }
  .button {
    margin-top: 20px;

    p {
      @media (min-width: $gyra-breakpoint-md) {
        font-size: 16px;
      }
      font-size: 14px;
      font-weight: bold;
      width: 100%;
      margin: 0;
    }
  }
}

.partition-five {
  height: auto;
  background-color: white;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0;
  @media (min-width: $gyra-breakpoint-xl) {
    flex-wrap: nowrap;
    padding: 260px 0;
  }
  position: relative;
  .left {
    z-index: 10;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (min-width: $gyra-breakpoint-xl) {
      width: 60%;
    }
    @media (min-width: $gyra-breakpoint-md) {
      align-items: center;
    }
  }
  h3 {
    margin-top: 20px;
    @media (min-width: $gyra-breakpoint-md) {
      margin-left: $gyra-margin-sides;
      text-align: left;
      margin-top: 122px;
    }
    text-align: center;
  }

  p {
    margin-top: 30px;
    @media (min-width: $gyra-breakpoint-md) {
      margin-left: calc(#{$gyra-margin-sides} + 46px);
      margin-right: 50px;
      width: auto;
      text-align: left;
      margin-top: 70px;
    }
    margin-right: 0;
    width: 80%;
    text-align: center;
  }
  .right {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .img {
    margin-top: 0;
    @media (min-width: $gyra-breakpoint-lg) {
      margin-top: 0;
    }
    background-image: url("../assets/images/for_business/Untitled design-3.png");
    width: 100vw;
    height: calc(1.14 * 100vw);
    @media (min-width: $gyra-breakpoint-sm) {
      width: 880px;
      height: 1004px;
    }
    @media (min-width: $gyra-breakpoint-md) {
      width: 703px;
      height: 804px;
      margin-top: 100px;
    }
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    @media (min-width: $gyra-breakpoint-md) {
      box-shadow: 10px 10px 50px 0 rgba(0, 0, 0, 0.16);
    }
    box-shadow: none;
  }
}
.page-gradient {
  background: rgb(255, 255, 255);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(245, 245, 245, 1) 100%
  );
}
</style>
